import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getActiveShifts } from "../actions/shiftActions";
import { getShiftTypes } from "../actions/shiftTypeActions";

import {
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Button,
} from "@material-ui/core";

import DataListWithSearchFilter from "./DataListWithSearchFilter";

import { KeyboardDateTimePicker } from "@material-ui/pickers";

import moment from "moment";
import formatPrice from "../utils/format-price";

let credentials = JSON.parse(localStorage.getItem("credentials"));

class ActiveProjectList extends Component {
  state = {
    shifts: [],

    cityZipcode: "",
    shiftTypes: [],
    beginDatetime: moment().startOf("week"),
    endDatetime: moment().endOf("week"),

    projectName: "",
    isEmployeeNeeded: true,

    optionShiftTypes: [],
  };

  componentDidMount() {
    this.refreshData();
  }

  previousWeek = () => {
    this.setState(
      {
        beginDatetime: (this.state.beginDatetime
          ? moment(this.state.beginDatetime)
          : moment().startOf("week")
        ).subtract(1, "week"),
        endDatetime: (this.state.endDatetime
          ? moment(this.state.endDatetime)
          : moment().endOf("week")
        ).subtract(1, "week"),
      },
      this.refreshData,
    );
  };

  currentWeek = () => {
    this.setState(
      {
        beginDatetime: moment().startOf("week"),
        endDatetime: moment().endOf("week"),
      },
      this.refreshData,
    );
  };

  nextWeek = () => {
    this.setState(
      {
        beginDatetime: (this.state.beginDatetime
          ? moment(this.state.beginDatetime)
          : moment().startOf("week")
        ).add(1, "week"),
        endDatetime: (this.state.endDatetime
          ? moment(this.state.endDatetime)
          : moment().endOf("week")
        ).add(1, "week"),
      },
      this.refreshData,
    );
  };

  filter = (shift) => {
    let isEmployeeNeeded = this.state.isEmployeeNeeded
      ? shift.numberOfEmployees > shift.employees.length
      : shift.numberOfEmployees <= shift.employees.length;

    if (isEmployeeNeeded) return true;

    return false;
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleSwitchChange = (e) =>
    this.setState({ [e.target.name]: e.target.checked });

  handleShiftTypeChange = (event) =>
    this.setState({ shiftTypes: event.target.value });

  refreshData() {
    this.setState({ optionShiftTypes: [], shifts: [] });

    this.props.getShiftTypes().then((response) => {
      this.setState({ optionShiftTypes: response });
    });

    this.props
      .getActiveShifts({
        cityZipcode: this.state.cityZipcode,
        shiftTypes: this.state.shiftTypes,
        beginDatetime: this.state.beginDatetime,
        endDatetime: this.state.endDatetime,
        projectName: this.state.projectName,
      })
      .then((shifts) => {
        this.setState({ shifts });
      });
  }

  render() {
    return (
      <Fragment>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              id="cityZipcode"
              name="cityZipcode"
              label="Stad/postcode"
              value={this.state.cityZipcode}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="shiftTypes">Dienstsoorten *</InputLabel>
            <Select
              id="shiftTypes"
              name="shiftTypes"
              multiple
              value={this.state.shiftTypes}
              onChange={this.handleShiftTypeChange}
              fullWidth
            >
              {this.state.optionShiftTypes.map((shiftType) => (
                <MenuItem
                  key={shiftType.id}
                  value={shiftType.id}
                  style={{
                    fontWeight:
                      this.state.shiftTypes.indexOf(shiftType.id) === -1
                        ? "normal"
                        : "500",
                  }}
                >
                  {shiftType.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid item xs={12} sm={6}>
            <KeyboardDateTimePicker
              clearable
              mask="__-__-____ __:__"
              id="beginDatetime"
              name="beginDatetime"
              label="Datum vanaf *"
              value={this.state.beginDatetime}
              format={"L LT"}
              onChange={(m) => this.setState({ beginDatetime: m })}
              fullWidth
              ampm={false}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KeyboardDateTimePicker
              clearable
              mask="__-__-____ __:__"
              id="endDatetime"
              name="endDatetime"
              label="Datum tot en met *"
              value={this.state.endDatetime}
              format={"L LT"}
              onChange={(m) => this.setState({ endDatetime: m })}
              fullWidth
              ampm={false}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              id="projectName"
              name="projectName"
              label="Projectnaam"
              value={this.state.projectName}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>

          {credentials.user.isAdmin && (
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Switch
                    id="isEmployeeNeeded"
                    name="isEmployeeNeeded"
                    checked={this.state.isEmployeeNeeded}
                    onChange={this.handleSwitchChange}
                    color="primary"
                  />
                }
                label="Openstaande diensten"
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.refreshData()}
            >
              Zoek
            </Button>
          </Grid>
        </Grid>

        <div style={{ textAlign: "center" }}>
          <Button onClick={this.previousWeek}>Vorige week</Button>
          <Button onClick={this.currentWeek}>Huidige week</Button>
          <Button onClick={this.nextWeek}>Volgende week</Button>
        </div>

        <DataListWithSearchFilter
          data={this.state.shifts.filter(this.filter).map((shift) => {
            const numberOfUnconfirmed = shift.employees.reduce(
              (acc, curr) =>
                acc + (curr.CompanyEmployeeShift.isConfirmedAt ? 0 : 1),
              0,
            );
            return {
              id: shift.id,
              title: `${shift.project.name} - ${formatPrice(
                shift.priceForDelivering,
              )} p/uur - ${
                shift.numberOfEmployees - shift.employees.length
              } nodig${
                numberOfUnconfirmed
                  ? ` - ${numberOfUnconfirmed} niet bevestigd`
                  : ""
              }`,
              subtitle: `${moment(shift.beginDatetime).format(
                "DD-MM-YYYY HH:mm",
              )} tot ${moment(shift.endDatetime).format(
                "DD-MM-YYYY HH:mm",
              )} in ${shift.project.city}`,
              onClick: () =>
                (window.location.href = `/shift/active/${shift.id}`),
            };
          })}
          isFetching={this.props.isFetching}
        />
      </Fragment>
    );
  }
}

ActiveProjectList.propTypes = {
  getActiveShifts: PropTypes.func.isRequired,
  getShiftTypes: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isFetching:
    state.shift.getActiveShifts.isFetching ||
    state.shifttype.getShiftTypes.isFetching,
});

export default connect(mapStateToProps, { getActiveShifts, getShiftTypes })(
  ActiveProjectList,
);



// WEBPACK FOOTER //
// ./src/components/ActiveShiftList.js